import React from "react";
import Services from "./ServicesCards";
import "../../styles/ServicesSection/ServicesSection.scss";
import { useTranslation } from "react-i18next";
import { ServicesHeader } from "./ServiceHeader";

export const ServicesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="servicesSection" id="servicesSection">
      <p>{t("what_we_do")}</p>
      <ServicesHeader />
      <Services />
    </section>
  );
};
